import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WarrantyformComponent } from './containers/warrantyform.component';
import { WarrantyformHeaderComponent } from './components/warrantyform-header/warrantyform-header.component';
import { WarrantyformActionComponent } from './components/warrantyform-action/warrantyform-action.component';
import { WarrantyformOmeComponent } from './components/warrantyform-ome/warrantyform-ome.component';
import { WarrantyformPartsComponent } from './components/warrantyform-parts/warrantyform-parts.component';
import { WarrantyformVehicleComponent } from './components/warrantyform-vehicle/warrantyform-vehicle.component';
import { CoreUiModule } from '@pos-app/core-ui';
import { VehiclesSelectionComponent } from '../vehicles/components/vehicles-selection/vehicles-selection.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    WarrantyformComponent,
    WarrantyformHeaderComponent,
    WarrantyformActionComponent,
    WarrantyformOmeComponent,
    WarrantyformPartsComponent,
    WarrantyformVehicleComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CoreUiModule, VehiclesSelectionComponent, MatIconModule],
  exports: [WarrantyformComponent, WarrantyformHeaderComponent, WarrantyformActionComponent],
})
export class WarrantyformModule {}
